module.exports = __webpack_public_path__ + "static/media/480.58d2b494.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-birch/dark/480.png
// module id = 1888
// module chunks = 2